import { isEmpty } from 'lodash';
import Constants from 'constants';
import configHelper from 'helper/Config/configHelper';
import utils from './utils';

export const localStorageCacheDecorator = async ({ func, options = {}, args }) => {
    const { storageKey = '', cacheTimeConfigKey = '' } = options;

    const { cacheTimer = {} } = utils.getConfig();
    const { [cacheTimeConfigKey]: comparator = 60 } = cacheTimer; //By default 1 mins

    const cache = utils.getLocalStorage(Constants.cache[storageKey]) || {},
        { timeLabel = '', content = {} } = cache,
        _shouldFetch = utils.shouldFetch(timeLabel, comparator);

    if (_shouldFetch || isEmpty(content)) {
        const response = await func(args);

        /**
         * @description if network response is return we can check success from status obj
         * or if custom object, we can send flag resSuccess for success flag
         */
        const { status = {} } = response || {};
        const { success = true } = status;
        const resSuccess = 'resSuccess' in response ? response.resSuccess : success;

        /**
         * @description response succes check because to only save in local storage when success is true
         * If resSuccess is false and content is in local storage, return content
         */
        if (resSuccess) {
            delete response.resSuccess;
            utils.setLocalStorage(Constants.cache[storageKey], {
                timeLabel: utils.currTimeSec(),
                content: response
            });
            return response;
        }
        if (isEmpty(content)) return response;
    }
    return content;
}
